module.exports = __webpack_public_path__ + "img/7_24.f1e42bbb.png";